export const actionTypes = {
    CLEAR_STORE: 'powertrainToolsV2/edit/CLEAR_STORE',
    GET_POWERTRAINS: 'powertrainToolsV2/GET_POWERTRAINS',
    ADD_POWERTRAIN: 'powertrainWizardV2/ADD_POWERTRAIN',
    DELETE_POWERTRAIN: 'powertrainWizardV2/DELETE_POWERTRAIN',
    EDIT_POWERTRAIN: 'powertrainWizardV2/EDIT_POWERTRAIN',
    SET_SELECTED_POWERTRAIN: 'powertrainToolsV2/SET_SELECTED_POWERTRAIN',
    SET_SEARCHBOX_FILTER: 'powertrainToolsV2/SET_SEARCHBOX_FILTER',
    SET_POWERTRAIN_FOR_EDITING: 'powertrainWizardV2/SET_POWERTRAIN_FOR_EDITING',

    //TO DO: edit when common powertrain list is used for configuration and overview
    RELOAD_OVERVIEW_POWERTRAINS_REQUEST: 'powertrainWizardV2/RELOAD_OVERVIEW_POWERTRAINS_REQUEST',
    GET_OVERVIEW_POWERTRAINS: 'overviewV2/GET_OVERVIEW_POWERTRAINS',

    //saga
    INITIALIZE_DATA_REQUEST: 'powertrainToolsV2/INITIALIZE_DATA_REQUEST',
    LOAD_POWERTRAINS_REQUEST: 'powertrainToolsV2/LOAD_POWERTRAINS_REQUEST',
    DELETE_POWERTRAIN_REQUEST: 'powertrainToolsV2/DELETE_POWERTRAIN_REQUEST',
    CONVERT_TO_LOCATION_REQUEST: 'powertrainToolsV2/CONVERT_TO_LOCATION_REQUEST',
    CONVERT_TO_LOCATION: 'powertrainToolsV2/CONVERT_TO_LOCATION',

    //Hierarchy
    GET_HIERARCHY_DATA_REQUEST: 'powertrainToolsV2/GET_HIERARCHY_DATA_REQUEST',
    GET_HIERARCHY_DATA_SETTINGS: 'powertrainToolsV2/GET_HIERARCHY_DATA_SETTINGS',
    UPDATE_HIERARCHY_DATA_REQUEST: 'powertrainToolsV2/UPDATE_HIERARCHY_DATA_REQUEST',
    UPDATE_HIERARCHY_DATA_SETTINGS: 'powertrainToolsV2/UPDATE_HIERARCHY_DATA_SETTINGS',
    SET_SELECTED_HIERARCHY_NODES: 'powertrainToolsV2/SET_SELECTED_HIERARCHY_NODES',
    SET_HIERARCHY_EXPANDED_NODES: 'powertrainToolsV2/SET_HIERARCHY_EXPANDED_NODES',
    SET_IS_EDIT_HIERARCHY: 'powertrainToolsV2/SET_IS_EDIT_HIERARCHY',
    SET_HIERARCHY_REQUEST_DATA: 'powertrainToolsV2/SET_HIERARCHY_REQUEST_DATA',
    SET_HIERARCHY_SELECTED_ASSETS: 'powertrainToolsV2/SET_HIERARCHY_SELECTED_ASSETS',

    // Error Modal
    SET_HIERARCHY_ERROR_MODAL: 'powertrainToolsV2/SET_HIERARCHY_ERROR_MODAL',
    SET_SAVE_FAILED: 'powertrainToolsV2/SET_SAVE_FAILED',
    SET_PARTIAL_POWERTRAIN_FAILURE: 'powertrainToolsV2/SET_PARTIAL_POWERTRAIN_FAILURE',

    // Convert to Location
    SET_CONVERSION_RESULT: 'powertrainToolsV2/SET_CONVERSION_RESULT',
    CLEAR_CONVERSION_RESULT: 'powertrainToolsV2/CLEAR_CONVERSION_RESULT',
};

// Pagination Constants
export const pageSize = 1000;
export const DEFAULT_PAGE_NUMBER = 1;

// UI Constants
export const UI_CONSTANTS = {
    // Icon dimensions for different contexts
    ICON_SIZES: {
        SMALL: { width: 16, height: 16 },
        MEDIUM: { width: 20, height: 20 },
        LARGE: { width: 22, height: 22 },
        EXTRA_LARGE: { width: 32, height: 32 },
        CUSTOM_24: { width: 24, height: 24 }
    },

    // Button icon dimensions (string format for some components)
    BUTTON_ICON_SIZE: { width: '24px', height: '24px' },

    // Timeout and delay values
    SEARCH_DELAY_MS: 700,

    // SVG validation icon size
    VALIDATION_ICON_SIZE: { width: 16, height: 16 }
};

// Asset Configuration Constants
// eslint-disable-next-line import/no-unused-modules
export const ASSET_CONSTANTS = {
    // Asset list page size
    PAGE_SIZE: 50
};

// Duplicate asset site error message key
export const DUPLICATE_ASSET_SITE_ERROR_MESSAGE_KEY = 'site';
